import React from 'react';
import './Packages.css';
import { Link } from 'react-router-dom';

export const Packages = () => {
  const packageInfo = [
    {
      place: '4 Days 3 Nights (Best Deal*)',
      info: [
        '12 Most Beautiful Nature Places Visit',
        '+1 Day Eco Picnic',
        '+1 Night Traditional Village Life Experience',
        'Hotel with Compliments',
        'Pickup from Sonbhadra Bus Stand/ Railway Station',
      ],
      price: '₹ 9000 INR /Person',
      placename: 'mukhafall',
    },
    {
      place: '3 Days 2 Nights',
      info: [
        '9 Most Beautiful Nature Places Visit',
        '+1 Day Eco Picnic',
        'Hotel with Compliments',
        'Pickup from Sonbhadra Bus Stand/ Railway Station',
      ],
      price: '₹ 6000 INR /Person',
      placename: 'fossilspark',
    },
    {
      place: '2 Days 1 Night',
      info: [
        '5 Most Beautiful Nature Places Visit',
        'Hotel with Compliments',
        'Pickup from Sonbhadra Bus Stand/ Railway Station',
      ],
      price: '₹ 3000 INR /Person',
      placename: 'rihanddam',
    },
    
    {
      place: '1 Day',
      info: [
        'Any Single Place Visit',
        'With Compliments',
        'Pickup from Sonbhadra Bus Stand/ Railway Station',
      ],
      price: '₹ 2500 INR /Person',
      placename: 'fossilspark',
    },
    {
      place: 'Bike Tour',
      info: [
        'Full 1 Day any Places Visit',
        'Pickup from Sonbhadra Bus Stand/ Railway Station',
      ],
      price: '₹ 1500 INR /Person',
      placename: 'fossilspark',
    },
    {
      place: 'Best Religious Tour (4 Days 3 Nights)',
      info: [
        
        'Pickup from Varanasi, Prayagraj, Mirzapur Bus Stand/ Railway Station/ Airport',
        'Prayagraj Tirthraj and Sangam Darshan, Kumbh Darshan in January',
        'Kashi Vishwanath Corridor Darshan, Ganga Aarti and Ganga Ghat Darshan, Kashi Manas Temple and Sankat Mochan Temple Darshan, Sarnath Buddhist Temple Darshan',
        'Vindhyachal Mata Dham Corridor Darshan',
        'Shivdwar Darshan',
        'Maa Mundeshwari Dham Darshan',
        '4 natural places wandering',
        'Hotel with Compliments',
        'One day Eco Picnic',

      ],
      price: '₹ 15000 INR /Person',
      placename: 'fossilspark',
    },
    {
      place: 'Religious Tour (4 Days 3 Nights)',
      info: [
        
        'Pickup from Varanasi, Mirzapur Bus Stand/ Railway Station/ Airport',
        'Kashi Vishwanath Corridor Darshan, Ganga Aarti and Ganga Ghat Darshan, Kashi Manas Temple and Sankat Mochan Temple Darshan',
        'Vindhyachal Mata Dham Corridor Darshan',
        'Shivdwar Darshan',
        'Maa Mundeshwari Dham Darshan',
        '4 natural places wandering',
        'Hotel with Compliments',
        'One day Eco Picnic',

      ],
      price: '₹ 12000 INR /Person',
      placename: 'fossilspark',
    },
    {
      place: 'Religious Tour (3 Days 2 Nights)',
      info: [
        
        'Pickup from Varanasi, Mirzapur Bus Stand/ Railway Station/ Airport',
        'Kashi Vishwanath Corridor Darshan, Ganga Aarti and Ganga Ghat Darshan, Kashi Manas Temple and Sankat Mochan Temple Darshan, Sarnath Buddhist Temple Darshan',
        'Vindhyachal Mata Dham Corridor Darshan',
        'Shivdwar Darshan',
        'Maa Mundeshwari Dham Darshan',
        'Hotel with Compliments',

      ],
      price: '₹ 9000 INR /Person',
      placename: 'fossilspark',
    },

  ];

  const notes = [
    'GST will be charged at 5% without Input Tax Credit (ITC) or 18% with ITC, on all tour packages',
    'For any Query realted to packages, contact us, will Love to assist You!',
    'Changes in pickup location, will add extra charges',
    '20% Discount in 3 Members Family visit tour',
    '30% Discount in 5 or more Members family tour visit',
    'All packages are customizable to suit your preferences',
    'Refunds are acceptable after booking, subject to terms and conditions',
  ];

  return (
    <div className="packages-container">
      <h1 className="page-heading">Our Tourist Packages</h1>
      <div className="packages-list">
        {packageInfo.map((element, index) => (
          <div className="package-card" key={index}>
            <h2 className="package-title">{element.place}</h2>
            <ul className="package-info">
              {element.info.map((item, idx) => (
                <li key={idx}>
                  <span className="info-icon">✓</span> {item}
                </li>
              ))}
            </ul>
            <p className="package-price">{element.price}</p>
          </div>
        ))}
        
      </div>
      
      <Link to="/book">
                <div className="btn">
                  <button className="book-btn">Book now</button>
                </div>
              </Link>

      <div className="notes-section">
        <h2 className="notes-heading">Notes</h2>
        <ul className="notes-list">
          {notes.map((note, index) => (
            <li key={index} className="note-item">
              {note}
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
};
